import axiosURL from 'axios'
import '../BasicField/BasicField.scss'
import { useFormContext } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

const EmailField = ({ name = 'email', validation, emailCheckResult, setEmailCheckResult }) => {
	const {
		register,
		setError,
		clearErrors,
		formState: { errors },
		trigger,
		getValues,
	} = useFormContext() /*register,formState*/
	const navigate = useNavigate()

	async function handleEmailCheck({ name, getValues, setEmailCheckResult }) {
		const value = getValues(name)
		try {
			await axiosURL.post(`${process.env.REACT_APP_API_ENDPOINT}/users/duplicatecheck`, {
				email: value,
			})
			setEmailCheckResult('available')
			clearErrors(name) // 성공한 경우만 clear
		} catch (error) {
			if (error?.response?.status === 409) {
				setEmailCheckResult('exists')
				setError(name, {
					type: 'manual',
					message: '이미 존재하는 이메일입니다.',
				})
			} else {
				// 네트워크 오류 등 기타 예외 처리
				console.error(error)
			}
		}
	}

	return (
		<div className="info-box">
			<span className="info-label"> 이메일</span>
			<div
				className={`fillin-box ${errors?.[name] || emailCheckResult === 'exists' ? 'error' : ''}`}>
				{/*fillin-box의 클래스 이름은 해당 필드에 에러가 났거나 이메일 체크 리절트가 '존재한다'로 나오면 에러를 갖다 붙여지게 된다*/}
				<input
					//name이라는 이름으로 input을 react hook form에 등록,유효성 검사 조건도 동시에 등록. 이 안에서 name이 email인 validationMap의 필드에서 required, pattern등으로 유효성 검사를 시행한다. 시행후 검증조건중 한가지에 걸리면 그것이 errors객체에 저장된다.
					{...register(name, validation)}
					className="fillin-input"
					type="text"
					placeholder="이메일@email.com"
					onChange={() => {
						// 입력값이 바뀌면 중복확인 결과 초기화
						setEmailCheckResult(null)
					}}
				/>
				<button
					type="button"
					className="btn-with-input"
					onClick={async () => {
						//“React Hook Form이 관리하는 필드 중에서 'email'이라는 이름으로 등록된 input필드에 대해 유효성 검사를 실행해줘.” 왜냐? props로 name이 전달되는데 기본값은 'email'이기 때문이다.
						// 앞의 isValid값이 Promise객체(아직 안정해졌을때 임의로 할당되는 객체, trigger는 오래걸리는 비동기함수라 await으로 끝날때 까지 기다려달라고 해서)로 받지 않게끔 하기
						const isValid = await trigger('email')
						if (!isValid) return
						await handleEmailCheck({
							name,
							getValues,
							setEmailCheckResult,
						})
					}}>
					중복확인
				</button>
			</div>
			<div>
				{/* 에러 메시지 */}
				{errors?.[name] && (
					<div className="validation-msg-group">
						{' '}
						<small className="validation-msg" style={{ color: 'red' }}>
							{errors[name].message}
						</small>
						{emailCheckResult === 'exists' && (
							<small
								style={{
									color: '4B4A48',
									textDecoration: 'underline',
									cursor: 'pointer',
									marginLeft: '8px',
								}}
								onClick={() => navigate('/login')}>
								로그인 하러가기
							</small>
						)}
					</div>
				)}
				{/* 중복 확인 메시지 */}
				{emailCheckResult === 'available' && !errors[name] && (
					<div>
						<small className="validation-msg" style={{ color: 'green' }}>
							사용 가능한 계정입니다.
						</small>
					</div>
				)}
			</div>
		</div>
	)
}

export default EmailField
